import { Injectable } from '@angular/core';
import constantURL from 'src/app/shared/constantURL';
import { BaseLoggedInPostService } from 'src/app/shared/services/base-logged-in-post.service';


@Injectable({
  providedIn: 'root'
})
export class handleBillImagesService extends BaseLoggedInPostService {
  _path = constantURL.BillPayments.image.upload;
  setImagePath(folderName:string){
    if(this._path.endsWith('uploadImage')){
      this._path+='/bill'+folderName;
    }
 }
}
